module.exports = __webpack_public_path__ + "5c56785355e2eeac270e0388cd2177bc.png";